<template>
  <div class="container">
    <!-- Search Box and Button -->
    <div class="dropdown-container">


      <div class="dropdown-item">
        <label for="fsmSelect">FSM</label>
        <select id="fsmSelect" v-model="selectedFsm" @change="onFsmChange" :disabled="isFsmLocked">
          <option value="">SELECT FSM</option>

          <!-- ✅ All FSMs only for OTHER -->
          <option v-if="isOtherUser" :value="ALL">All FSMs</option>

          <option v-for="fsm in fsmList" :key="fsm.profile_id ?? fsm.id" :value="String(fsm.profile_id)">
            {{ fsm.name }}
          </option>
        </select>
      </div>

      <div class="dropdown-item">
        <label for="asmSelect">ASM</label>
        <select id="asmSelect" v-model="selectedAsm" @change="onAsmChange" :disabled="isAsmLocked">
          <option value="">SELECT ASM</option>

          <!-- ✅ All ASMs for FSM / OTHER -->
          <option v-if="isFsmUser || isOtherUser" :value="ALL">All ASMs</option>

          <option v-for="asm in asmList" :key="asm.profile_id ?? asm.id" :value="String(asm.profile_id)">
            {{ asm.name }}
          </option>
        </select>
      </div>

      <div class="dropdown-item">
        <label for="distributorSelect">Distributor</label>
        <select id="distributorSelect" v-model="selectedDistributor" @change="onDistributorChange"
          :disabled="isDistributorLocked">
          <option value="">SELECT Distributor</option>

          <!-- ✅ All Distributors for FSM / ASM / OTHER -->
          <option v-if="isFsmUser || isAsmUser || isOtherUser" :value="ALL">All Distributors</option>

          <option v-for="distributor in distributorList" :key="distributor.profile_id ?? distributor.id"
            :value="String(distributor.profile_id)">
            {{ distributor.name }}
          </option>
        </select>
      </div>

      <div class="dropdown-item">
        <label for="dealerSelect">Dealer</label>
        <select id="dealerSelect" v-model="selectedDealer" :disabled="!canUseDealerFilter">
          <!-- ✅ All Dealers -->
          <option value="">All Dealers</option>

          <option v-for="dealer in dealerList" :key="dealer.profile_id ?? dealer.id" :value="String(dealer.profile_id)">
            {{ dealer.name }}
          </option>
        </select>
      </div>


      <div class="dropdown-item">
        <label for="orderNo">Order No</label>
        <input type="text" v-model="searchQuery" placeholder="Search..." class="search-input"
          @keydown.enter="performSearch" />
      </div>

      <!-- First Date Picker -->
      <div class="dropdown-item">
        <label for="datePicker">Start Date</label>
        <input type="date" v-model="selectedDate" class="search-input" @change="handleDateChange" :max="currentDate"
          @blur="validateStartDate" />
      </div>

      <!-- Second Date Picker -->
      <div class="dropdown-item">
        <label for="secondDatePicker">End Date</label>
        <input type="date" v-model="secondSelectedDate" class="search-input" @change="handleDateChange"
          :max="currentDate" @blur="validateEndDate" />
      </div>

      <div class="search-container">
        <button @click="performSearch" class="btn button-default mt-4" :disabled="loading">
          {{ loading ? "Searching..." : "Search" }}
        </button>

      </div>
    </div>

    <!-- Loading Spinner -->
    <div v-if="loading" class="loading-spinner mt-3">
      <i class="fa fa-spinner fa-spin"></i> Loading...
    </div>


    <div v-else-if="searchedOnce && noOrdersFound" class="no-orders text-center">
      No orders found.
    </div>


    <!-- Orders Table -->
    <div v-else-if="searchedOnce && orderList.length" class="col-sm-12">
      <div class="card">
        <div class="table-responsive">
          <table class="table">
            <thead>
              <tr class="border-bottom-primary">
                <th scope="col">Date</th>
                <th scope="col">Dealer Name</th>
                <th scope="col">Order No</th>
                <th scope="col">View</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in orderList" :key="index">
                <td>{{ formatDate(item.created_at) }}</td>
                <td>{{ item.business_name }}</td>
                <td><i class="fa fa-flag" aria-hidden="true"></i> {{ item.increment_id }}</td>
                <td>
                  <i @click="viewDetails(item.id)" class="fa fa-eye" aria-hidden="true"></i>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>




    <!-- Order Details Modal -->
    <ViewOrderDetails :show="showModal" :order-id="selectedOrderId" @close="closeModal" />
  </div>
</template>

<script>
import {
  fetchFsmList,
  fetchAsmList,
  fetchDistributorList,
  searchOrder,
  fetchDealerListManagement
} from '@/services/dataService';
import { useToast } from "vue-toastification";
import ViewOrderDetails from '@/pages/Modal/viewOrderDetails.vue';

export default {
  name: 'OrderManagement',
  components: {
    ViewOrderDetails
  },
  data() {
    return {
      fsmList: [],
      asmList: [],
      distributorList: [],
      dealerList: [],
      selectedFsm: '',
      selectedAsm: '',
      selectedDistributor: '',
      selectedDealer: '',

      userLabel: "",
      roleKey: "OTHER",
      myProfileId: Number(localStorage.getItem("profile_id") || 0),
      isFsmLocked: false,
      isAsmLocked: false,
      isDistributorLocked: false,

      searchQuery: '',
      currentDate: new Date().toISOString().split('T')[0],
      selectedDate: new Date().toISOString().split('T')[0],
      secondSelectedDate: new Date().toISOString().split('T')[0],
      orderList: [],
      showModal: false,
      selectedOrderId: null,
      loading: false,
      noOrdersFound: false,

      searchedOnce: false,
      ALL: "__all__",

    };
  },

  computed: {
    isDistributorUser() { return this.roleKey === "DIS"; },
    isAsmUser() { return this.roleKey === "ASM"; },
    isFsmUser() { return this.roleKey === "FSM"; },
    isOtherUser() { return this.roleKey === "OTHER"; },

    // ✅ dealer filter only when a real distributor selected
    canUseDealerFilter() {
      return !!this.selectedDistributor && this.selectedDistributor !== this.ALL;
    }
  },


  watch: {
    showModal(newVal) {
      if (newVal) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = 'auto';
      }
    }
  },

  created() {
    this.loginAndFetchData();
  },

  beforeUnmount() {
    document.body.style.overflow = 'auto';
  },

  methods: {

    handleDateChange() {
      // validate each field first
      this.validateStartDate(false);
      this.validateEndDate(false);

      // validate range if both exist
      if (this.selectedDate && this.secondSelectedDate) {
        if (this.secondSelectedDate < this.selectedDate) {
          this.showErrorToast("Invalid date range picked.");
          this.secondSelectedDate = "";
        }
      }
    },

    isValidISODate(dateStr) {
      // must be YYYY-MM-DD (type="date" returns this)
      if (!dateStr || typeof dateStr !== "string") return false;

      // block manual formats like 2025/11/31
      if (dateStr.includes("/")) return false;

      const m = dateStr.match(/^(\d{4})-(\d{2})-(\d{2})$/);
      if (!m) return false;

      const y = Number(m[1]);
      const mo = Number(m[2]);
      const d = Number(m[3]);

      // build date and verify it didn't overflow (e.g. 2025-11-31)
      const dt = new Date(y, mo - 1, d);
      if (
        dt.getFullYear() !== y ||
        dt.getMonth() !== mo - 1 ||
        dt.getDate() !== d
      ) return false;

      return true;
    },

    validateStartDate(showToast = true) {
      if (!this.selectedDate) return true; // required check happens in performSearch

      if (!this.isValidISODate(this.selectedDate)) {
        if (showToast) this.showErrorToast("Invalid Start Date");
        this.selectedDate = "";
        return false;
      }

      // future block
      if (this.selectedDate > this.currentDate) {
        if (showToast) this.showErrorToast("Start Date cannot be in the future");
        this.selectedDate = "";
        return false;
      }

      return true;
    },

    validateEndDate(showToast = true) {
      if (!this.secondSelectedDate) return true; // required check happens in performSearch

      if (!this.isValidISODate(this.secondSelectedDate)) {
        if (showToast) this.showErrorToast("Invalid End Date");
        this.secondSelectedDate = "";
        return false;
      }

      // future block
      if (this.secondSelectedDate > this.currentDate) {
        if (showToast) this.showErrorToast("End Date cannot be in the future");
        this.secondSelectedDate = "";
        return false;
      }

      return true;
    },

    validateDatesForSearch() {
      // REQUIRED
      if (!this.selectedDate) { this.showErrorToast("Please select valid Start Date"); return false; }
      if (!this.secondSelectedDate) { this.showErrorToast("Please select valid End Date"); return false; }

      // VALID
      if (!this.validateStartDate(true)) return false;
      if (!this.validateEndDate(true)) return false;

      // RANGE
      if (this.secondSelectedDate < this.selectedDate) {
        this.showErrorToast("Invalid date range picked.");
        return false;
      }

      return true;
    },


    showSuccessToast(message) {
      const toast = useToast();
      toast.success(message, {
        position: "top-right",
        timeout: 3000,
      });
    },


    showErrorToast(message) {
      const toast = useToast();
      toast.error(message, {
        position: "top-right",
        timeout: 3000,
      });
    },

    detectRoleKeyFromStorage(labelRaw) {
      const u = String(labelRaw || "").toUpperCase().trim();
      if (u === "DISTRIBUTOR" || u.startsWith("DISTRIBUTOR") || u === "DIS" || u.startsWith("DIS_")) return "DIS";
      if (u === "ASM" || u.startsWith("ASM_")) return "ASM";
      if (u === "FSM" || u.startsWith("FSM_")) return "FSM";
      return "OTHER";
    },

    validateFiltersOneByOne() {
      if (!this.selectedFsm) {
        this.showErrorToast("Please select FSM");
        return false;
      }
      if (!this.selectedAsm) {
        this.showErrorToast("Please select ASM");
        return false;
      }
      if (!this.selectedDistributor) {
        this.showErrorToast("Please select Distributor");
        return false;
      }
      return true; // dealer can stay "All Dealers"
    },





    async loginAndFetchData() {
      this.loading = true;
      await this.$nextTick();

      const token = localStorage.getItem('token_set') || '';
      if (!token) {
        this.loading = false;
        console.error('Token not found in localStorage');
        return;
      }

      try {
        await this.loadFsmList(token);
      } catch (error) {
        console.error('Error:', error);
      } finally {
        this.loading = false;
      }

      // ✅ init role (filtering style)
      const label =
        localStorage.getItem("user_label") ||
        localStorage.getItem("userLabel") ||
        localStorage.getItem("role") ||
        "";

      this.userLabel = String(label);
      this.roleKey = this.detectRoleKeyFromStorage(this.userLabel);
      this.myProfileId = Number(localStorage.getItem("profile_id") || 0);

      try {
        await this.loadFsmList(token);
      } catch (error) {
        console.error('Error:', error);
      }
    },

    //   const profileId = localStorage.getItem('profile_id');
    //   if (!profileId) {
    //     console.error('Profile ID not found in localStorage');
    //     return;
    //   }
    //   try {
    //     const response = await fetchFsmList(profileId, token);
    //     this.fsmList = response.data.data || [];

    //     if (this.fsmList.length === 1) {
    //       this.selectedFsm = this.fsmList[0].profile_id;
    //       await this.loadAsmList();
    //     }
    //   } catch (error) {
    //     console.error('Error loading FSM list:', error);
    //   }
    // },


    async loadFsmList(token) {
      const profileId = localStorage.getItem('profile_id');
      if (!profileId) {
        console.error('Profile ID not found in localStorage');
        return;
      }

      try {
        const response = await fetchFsmList(profileId, token);
        this.fsmList = response.data.data || [];

        // ✅ NO auto-select here (same filtering style)
        this.selectedFsm = "";
        this.selectedAsm = "";
        this.selectedDistributor = "";
        this.selectedDealer = "";
        this.asmList = [];
        this.distributorList = [];
        this.dealerList = [];

        this.isDistributorLocked = false;
      } catch (error) {
        console.error('Error loading FSM list:', error);
      }
    },

    // ✅ NEW: cascade methods (same style)
    async onFsmChange() {
      this.selectedAsm = "";
      this.selectedDistributor = "";
      this.selectedDealer = "";

      this.asmList = [];
      this.distributorList = [];
      this.dealerList = [];

      if (this.selectedFsm === this.ALL) {
        this.selectedAsm = this.ALL;
        this.selectedDistributor = this.ALL;
        return;
      }

      if (!this.selectedFsm) return;
      if (this.selectedFsm === this.ALL) return; // keep empty below until user chooses ASM etc.

      await this.loadAsmList();
    },


    //   if (this.selectedFsm) {
    //     try {
    //       const profileId = localStorage.getItem('profile_id');
    //       const token = localStorage.getItem('token_set') || '';
    //       const response = await fetchAsmList(profileId, this.selectedFsm, token);
    //       this.asmList = response.data.data || [];
    //       this.selectedAsm = '';
    //       this.selectedDistributor = '';
    //       this.selectedDealer = '';

    //       if (this.asmList.length === 1) {
    //         this.selectedAsm = this.asmList[0].profile_id;
    //         await this.loadDistributorList();
    //       }
    //     } catch (error) {
    //       console.error('Error loading ASM list:', error);
    //     }
    //   } else {
    //     this.asmList = [];
    //     this.selectedAsm = '';
    //     this.selectedDistributor = '';
    //     this.selectedDealer = '';
    //   }
    // },

    async loadAsmList() {
      if (this.selectedFsm) {
        try {
          const profileId = localStorage.getItem('profile_id');
          const token = localStorage.getItem('token_set') || '';
          const response = await fetchAsmList(profileId, this.selectedFsm, token);
          this.asmList = response.data.data || [];

          // reset below
          this.selectedAsm = "";
          this.selectedDistributor = "";
          this.selectedDealer = "";
          this.distributorList = [];
          this.dealerList = [];
          this.isDistributorLocked = false;
        } catch (error) {
          console.error('Error loading ASM list:', error);
        }
      } else {
        this.asmList = [];
        this.selectedAsm = '';
        this.selectedDistributor = '';
        this.selectedDealer = '';
      }
    },

    async onAsmChange() {
      this.selectedDistributor = "";
      this.selectedDealer = "";

      this.distributorList = [];
      this.dealerList = [];

      this.isDistributorLocked = false;


      if (this.selectedAsm === this.ALL) {
        this.selectedDistributor = this.ALL;
        return;
      }

      if (!this.selectedAsm) return;
      if (this.selectedAsm === this.ALL) return;

      await this.loadDistributorList();
    },




    async loadDistributorList() {
      if (this.selectedAsm) {
        try {
          const fsmId = this.selectedFsm;
          const token = localStorage.getItem('token_set') || '';
          const response = await fetchDistributorList(fsmId, this.selectedAsm, token);
          let list = response.data.data || [];

          this.selectedDistributor = "";
          this.selectedDealer = "";
          this.dealerList = [];
          this.isDistributorLocked = false;

          // ✅ ONLY distributor login: lock own distributor
          if (this.isDistributorUser && this.myProfileId) {
            const mine = list.find(d => Number(d.profile_id) === Number(this.myProfileId));
            if (mine) {
              list = [mine];
              this.selectedDistributor = String(mine.profile_id);
              this.isDistributorLocked = true;

              // programmatic set doesn't trigger @change
              await this.loadDealerList();
            }
          }

          this.distributorList = list;
        } catch (error) {
          console.error('Error loading Distributor list:', error);
        }
      } else {
        this.distributorList = [];
        this.selectedDistributor = '';
        this.selectedDealer = '';
      }
    },

    async onDistributorChange() {
      this.selectedDealer = "";
      this.dealerList = [];

      if (!this.selectedDistributor) return;
      if (this.selectedDistributor === this.ALL) return;


      await this.loadDealerList();
    },

    
    //   if (this.selectedDistributor) {
    //     try {
    //       const profileId = localStorage.getItem('profile_id');
    //       const token = localStorage.getItem('token_set') || '';
    //       const response = await fetchDealerListManagement(profileId, this.selectedDistributor, token);
    //       this.dealerList = response.data.data || [];
    //       this.selectedDealer = '';

    //       if (this.dealerList.length === 1) {
    //         this.selectedDealer = this.dealerList[0].profile_id;
    //       }
    //     } catch (error) {
    //       console.error('Error loading dealer_visit list:', error);
    //     }
    //   } else {
    //     this.dealerList = [];
    //   }
    // },

    // async loadDealerList() {
    //   if (this.selectedDistributor) {
    //     await this.loadDealerListManagement();
    //   } else {
    //     this.dealerList = [];
    //   }
    // },


    async loadDealerList() {
      if (this.selectedDistributor) {
        await this.loadDealerListManagement();
      } else {
        this.dealerList = [];
      }
    },

    async loadDealerListManagement() {
      if (this.selectedDistributor && this.selectedDistributor !== this.ALL) {
        try {
          const profileId = localStorage.getItem('profile_id');
          const token = localStorage.getItem('token_set') || '';
          const response = await fetchDealerListManagement(profileId, this.selectedDistributor, token);

          this.dealerList = response.data.data || [];
          this.selectedDealer = ""; // keep All Dealers by default
        } catch (error) {
          console.error('Error loading dealer_visit list:', error);
        }
      } else {
        this.dealerList = [];
      }
    },


  
    //   this.loading = true;
    //   this.orderList = [];
    //   this.noOrdersFound = false;
    //   try {
    //     const token = localStorage.getItem('token_set') || '';
    //     const response = await searchOrder({
    //       fsm_id: this.selectedFsm || null,
    //       asm_id: this.selectedAsm || null,
    //       distributor_id: this.selectedDistributor || null,
    //       dealer_id: this.selectedDealer || null,
    //       order_no: this.searchQuery || null,
    //       date: this.selectedDate || null,
    //       second_date: this.secondSelectedDate || null
    //     }, token);

    //     if (this.selectedDate && this.secondSelectedDate) {
    //       const startDate = new Date(this.selectedDate).toISOString().split('T')[0];
    //       const endDate = new Date(this.secondSelectedDate).toISOString().split('T')[0];
    //       this.orderList = response.data.data.filter(order => {
    //         const orderDate = new Date(order.created_at).toISOString().split('T')[0];
    //         return orderDate >= startDate && orderDate <= endDate;
    //       });
    //     } else {
    //       this.orderList = response.data.data;
    //     }

    //     if (this.orderList.length === 0) {
    //       this.noOrdersFound = true;
    //     }
    //   } catch (error) {
    //     console.error('Error searching orders:', error);
    //   } finally {
    //     this.loading = false;
    //   }
    // },


   async performSearch() {
  if (!this.validateFiltersOneByOne()) {
    this.searchedOnce = true;
    return;
  }

  if (!this.validateDatesForSearch()) {
    this.searchedOnce = true;
    return;
  }

  this.loading = true;
  this.searchedOnce = false;
  this.orderList = [];
  this.noOrdersFound = false;

  await this.$nextTick();

  try {
    const token = localStorage.getItem("token_set") || "";

    const response = await searchOrder({
      fsm_id: (this.selectedFsm && this.selectedFsm !== this.ALL) ? this.selectedFsm : null,
      asm_id: (this.selectedAsm && this.selectedAsm !== this.ALL) ? this.selectedAsm : null,
      distributor_id: (this.selectedDistributor && this.selectedDistributor !== this.ALL) ? this.selectedDistributor : null,
      dealer_id: this.selectedDealer || null,
      order_no: this.searchQuery || null,
      date: this.selectedDate || null,
      second_date: this.secondSelectedDate || null
    }, token);

    const rows = response?.data?.data || [];

    // ✅ keep your local date filtering (safe-guarded)
    if (this.selectedDate && this.secondSelectedDate) {
      const startDate = new Date(this.selectedDate).toISOString().split("T")[0];
      const endDate = new Date(this.secondSelectedDate).toISOString().split("T")[0];

      this.orderList = rows.filter(order => {
        const orderDate = new Date(order.created_at).toISOString().split("T")[0];
        return orderDate >= startDate && orderDate <= endDate;
      });
    } else {
      this.orderList = rows;
    }

    // ✅ now decide what to show
    if (this.orderList.length === 0) {
      this.noOrdersFound = true;
    } else {
      this.noOrdersFound = false;
      this.showSuccessToast("Report Generated Successfully");
    }

  } catch (error) {
    console.error("Error searching orders:", error);
  } finally {
    this.loading = false;
    this.searchedOnce = true;
  }
},


    viewDetails(id) {
      this.selectedOrderId = id;
      this.showModal = true;
    },

    closeModal() {
      this.showModal = false;
      this.selectedOrderId = null;
      document.body.style.overflow = 'auto';
    },

    formatDate(dateString) {
      const options = { year: 'numeric', month: 'long', day: 'numeric' };
      return new Date(dateString).toLocaleDateString(undefined, options);
    }
  }
};
</script>

<style scoped>
html,
body {
  height: 100%;
  margin: 0;
  padding: 0;
  background-color: #f0f0f0;
}

.container {
  background-color: #ffffff;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  padding: 20px;
  margin: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
}

.loading-spinner {
  font-size: 18px;
  text-align: center;
  margin-top: 20px;
  color: #007bff;
}

.no-orders {
  font-size: 18px;
  color: #6c757d;
  margin-top: 20px;
  padding: 40px;
}

.dropdown-container {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 15px;
  width: 100%;
  justify-content: center;
  margin-bottom: 20px;
}

.dropdown-item {
  flex: 1;
  min-width: 180px;
  max-width: 250px;
}

label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
  font-size: 14px;
}

input[type="text"] {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
  width: 100%;
}

input[type="date"] {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
  width: 100%;
}

select {
  width: 100%;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
  font-size: 14px;
  transition: border-color 0.3s, box-shadow 0.3s;
}

select:focus {
  border-color: #007bff;
  box-shadow: 0 0 5px rgba(38, 143, 255, 0.5);
  outline: none;
}

.search-input {
  flex: 1;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
  font-size: 14px;
  transition: border-color 0.3s, box-shadow 0.3s;
}

.search-input:focus {
  border-color: #007bff;
  box-shadow: 0 0 5px rgba(38, 143, 255, 0.5);
  outline: none;
}

.search-container {
  display: flex;
  align-items: center;
  justify-content: left;
}

.btn.button-default {
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  background-color: #007bff;
  color: #ffffff;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.3s, transform 0.3s;
}

.btn.button-default:hover {
  background-color: #0056b3;
  transform: scale(1.05);
}

.btn.button-default:active {
  transform: scale(0.95);
}

.table-container {
  width: 100%;
  margin-top: 20px;
}

.table {
  width: 100%;
  border-collapse: collapse;
}

.table th,
.table td {
  padding: 10px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

.table th {
  background-color: #f9f9f9;
  font-weight: bold;
}

.table td {
  background-color: #ffffff;
}

.table td i.fa-flag {
  margin-right: 8px;
  color: blue;
}

.fa-eye {
  cursor: pointer;
  transition: color 0.3s, transform 0.3s;
}

.fa-eye:hover {
  color: #0056b3;
  transform: scale(1.2);
}

.fa-eye:active {
  transform: scale(1.1);
}

@media (max-width: 768px) {
  .dropdown-container {
    grid-template-columns: 1fr;
    gap: 10px;
  }

  .dropdown-item {
    max-width: none;
    width: 100%;
  }
}
</style>